import React from 'react';
import SegmentedBar, {
    SegmentedBarSegment,
} from '../SegmentedBar/SegmentedBar';
import PaginationNode from './PaginationNode';

export interface IPaginationBarProps {
    className?: string;
    totalItems: number;
    pageSize: number;
    currentPage: number;
    onChange?: (page: number) => void;
    actions?: React.ReactNode;
}

const PaginationBar = (props: IPaginationBarProps) => {
    const { className, totalItems, pageSize, currentPage, onChange, actions } =
        props;

    const pagesCount = pageSize > 0 ? Math.ceil(totalItems / pageSize) : 1;

    if (pagesCount <= 1 && !actions) {
        return null;
    }

    const segments: SegmentedBarSegment[] = [
        { key: 'actions', node: actions },
        {
            key: 'pagination',
            node: (
                <PaginationNode
                    pagesCount={pagesCount}
                    currentPage={currentPage}
                    onChange={onChange}
                />
            ),
        },
    ];

    return <SegmentedBar segments={segments} className={className} />;
};

export default PaginationBar;
